var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
      'foodBankItem':true,
       'foodBankItem__active':_vm.active
}},[_c('div',{staticClass:"foodBankItem__img"},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.imgUrl + _vm.foodBankItem.foodImgUrl,"fit":"fit"}})],1),_c('div',{staticClass:"foodBankItem__name"},[_vm._v(" "+_vm._s(_vm.foodBankItem.foodName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }